var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobilepay = function SvgMobilepay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    height: 58,
    viewBox: "0 0 179.997 58"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobilepay_svg__a",
    x1: -168.53,
    y1: 6.78,
    x2: -168.518,
    y2: 6.817,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#487574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302,
    stopColor: "#504678",
    stopOpacity: 0.616
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#504678",
    stopOpacity: 0.282
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#504678",
    stopOpacity: 0.075
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504678",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobilepay_svg__b",
    x1: -202.19,
    y1: 8.859,
    x2: -202.179,
    y2: 8.891,
    xlinkHref: "#mobilepay_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobilepay_svg__c",
    x1: -13.74,
    y1: 4.676,
    x2: -13.729,
    y2: 4.684,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#504678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#504678",
    stopOpacity: 0.871
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#504678",
    stopOpacity: 0.537
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504678",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 419"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3097",
    d: "M21.833 58a4.906 4.906 0 0 1-4.533-3.028L.375 14.116a4.9 4.9 0 0 1 2.652-6.4L20.752.374a4.9 4.9 0 0 1 6.4 2.652l16.925 40.857a4.9 4.9 0 0 1-2.652 6.4l-17.727 7.346a4.91 4.91 0 0 1-1.865.371Zm.794-55.363a2.258 2.258 0 0 0-.865.173L4.035 10.152a2.262 2.262 0 0 0-1.224 2.955l16.925 40.859a2.264 2.264 0 0 0 2.953 1.224l17.727-7.348a2.26 2.26 0 0 0 1.224-2.955L24.715 4.034a2.265 2.265 0 0 0-2.088-1.397Z",
    fill: "#487574"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 58",
    transform: "rotate(-22.5 29.831 -61.574)",
    opacity: 0.7,
    fill: "url(#mobilepay_svg__a)",
    style: {
      isolation: "isolate"
    },
    d: "M0 0h2.638v17.51H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 59",
    transform: "rotate(-22.5 76.448 -70.839)",
    opacity: 0.7,
    fill: "url(#mobilepay_svg__b)",
    style: {
      isolation: "isolate"
    },
    d: "M0 0h2.638v19.821H0z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3098",
    d: "M37.437 30.037a29.911 29.911 0 0 0-12.074 8.493l-7.145-17.258a30.161 30.161 0 0 1 12.074-8.493c5.069-2.1 10.191-3.119 14.542-2.526l7.148 17.257a30.177 30.177 0 0 0-14.545 2.527Z",
    fill: "#5a78ff"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3099",
    d: "M198.364 322.315a29.911 29.911 0 0 0-12.074 8.493l-7.145-17.258a30.161 30.161 0 0 1 12.074-8.493c5.069-2.1 10.191-3.119 14.542-2.526l7.148 17.257a30.177 30.177 0 0 0-14.545 2.527Z",
    transform: "translate(-160.927 -292.278)",
    opacity: 0.9,
    fill: "url(#mobilepay_svg__c)",
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3100",
    d: "M37.437 30.037a29.911 29.911 0 0 0-12.074 8.493l-7.145-17.258a30.161 30.161 0 0 1 12.074-8.493c5.069-2.1 10.191-3.119 14.542-2.526l7.148 17.257a30.177 30.177 0 0 0-14.545 2.527Z",
    fill: "#2a4d4f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3101",
    d: "M39.766 35.299a29.9 29.9 0 0 0-14.4 3.224V21.074a30.2 30.2 0 0 1 14.4-3.225c5.487 0 10.609 1.018 14.4 3.23v17.449a30.176 30.176 0 0 0-14.4-3.229Zm28.033.015 4.438-14.031a.462.462 0 0 1 .412-.354h2.228a.547.547 0 0 1 .438.354l3.457 8.854c.067.176.243.193.3 0l3.43-8.854a.549.549 0 0 1 .437-.354h2.228a.461.461 0 0 1 .412.354l4.39 14.033a.339.339 0 0 1-.027.334.335.335 0 0 1-.3.145h-2.649a.385.385 0 0 1-.394-.3l-2.818-9.116c-.042-.176-.243-.176-.3 0l-3.363 9.048a.494.494 0 0 1-.479.369h-1.556c-.243 0-.37-.134-.463-.369l-3.43-9.048c-.067-.176-.245-.176-.287 0l-2.883 9.116a.393.393 0 0 1-.412.3h-2.523a.325.325 0 0 1-.276-.16.329.329 0 0 1-.011-.321Zm23.014-5.044a5.886 5.886 0 1 1 5.886 5.768 5.695 5.695 0 0 1-5.886-5.768Zm8.745 0a2.893 2.893 0 1 0-2.859 3.085 2.968 2.968 0 0 0 2.843-3.085Zm8.206 4.615c-.218-.176-.412-.109-.412.194v.285a.413.413 0 0 1-.4.412H104.9a.429.429 0 0 1-.412-.412V21.331a.429.429 0 0 1 .412-.412h2.162a.411.411 0 0 1 .394.412v4c0 .285.194.37.5.151a4.808 4.808 0 0 1 2.868-.959 5.462 5.462 0 0 1 5.289 5.77 5.515 5.515 0 0 1-5.381 5.768 4.475 4.475 0 0 1-2.968-1.178Zm5.381-4.59a2.893 2.893 0 1 0-5.768 0 2.925 2.925 0 0 0 2.867 3.034 2.966 2.966 0 0 0 2.9-3.059Zm4.784-8.351a1.682 1.682 0 1 1 1.683 1.683 1.682 1.682 0 0 1-1.681-1.683Zm.152 13.455V25.225a.413.413 0 0 1 .4-.412h2.161a.429.429 0 0 1 .445.412v10.14a.429.429 0 0 1-.412.412h-2.193a.413.413 0 0 1-.4-.412Zm5.407-3.33V21.331a.413.413 0 0 1 .4-.412h2.161a.429.429 0 0 1 .412.412v10.806c0 .7.3 1.16 1.068 1.16a.413.413 0 0 1 .412.412v1.79a.413.413 0 0 1-.412.4c-2.88-.004-4.04-.946-4.04-3.83Zm5.256-1.732a5.684 5.684 0 1 1 11.367.042c0 .394-.109.723-.5.723h-7.52c-.194 0-.261.109-.243.287a2.522 2.522 0 0 0 2.691 2.161 2.678 2.678 0 0 0 2.077-.942.838.838 0 0 1 .7-.352h2.01c.352 0 .5.243.37.588a5.76 5.76 0 0 1-10.931-2.523Zm7.979-1.009c.151 0 .218-.067.193-.243a2.52 2.52 0 0 0-2.522-2.052 2.589 2.589 0 0 0-2.523 1.992c-.042.152 0 .3.178.3Zm5.205 6.037V21.331a.41.41 0 0 1 .394-.412h6.886c3.146 0 5.29 1.834 5.29 4.92s-2.431 4.986-5.441 4.986h-3.649a.367.367 0 0 0-.3.11.361.361 0 0 0-.1.3v4.129a.428.428 0 0 1-.412.412h-2.265a.412.412 0 0 1-.4-.411Zm7.13-7.079a2.371 2.371 0 0 0 2.295-2.431 2.244 2.244 0 0 0-2.3-2.313h-3.673c-.261 0-.37.136-.37.4v3.978c0 .26.109.394.37.394Zm6.5 1.984a5.56 5.56 0 0 1 5.423-5.77 4.412 4.412 0 0 1 2.91 1.118c.193.178.412.152.412-.109v-.285a.4.4 0 0 1 .4-.4h2.052a.429.429 0 0 1 .412.412v7.215c0 .546.193.79.572.841a.377.377 0 0 1 .369.352v1.9a.37.37 0 0 1-.369.37c-1.447 0-2.3-.412-2.776-1.245-.134-.218-.285-.26-.5-.042a4.825 4.825 0 0 1-3.522 1.463 5.542 5.542 0 0 1-5.374-5.826Zm8.745 0a2.884 2.884 0 1 0-1.371 2.68 2.883 2.883 0 0 0 1.372-2.68Zm4.818 9.358v-1.79a.413.413 0 0 1 .412-.4 3.068 3.068 0 0 0 3.145-2.1 1.213 1.213 0 0 0-.085-.841l-4.018-9.1a.394.394 0 0 1 .352-.588h2.161c.22 0 .354.176.438.394l2.523 5.819c.176.463.461.438.655 0l2.405-5.835c.084-.218.193-.352.412-.352h2.075a.378.378 0 0 1 .37.521l-4.136 9.788c-1.505 3.566-3.1 4.893-6.3 4.893a.427.427 0 0 1-.408-.409Z",
    fill: "#487574"
  }))));
};
export default SvgMobilepay;